import React, { Component } from 'react';
import { Card, Divider, message, Row, Tag } from 'antd';
import DescriptionList from '@comm/DescriptionList';
import { queryProjInfo } from '@api/task';
import moment from 'moment';
import { BackBtn } from '@comm/BackBtn';

const { Description } = DescriptionList;

class PageInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };
  }

  componentDidMount() {
    const { uuid } = this.props.params;
    this.getProjInfo(uuid);
  }

  // 获取项目信息
  getProjInfo = uuid => {
    queryProjInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { data = {} } = this.state;
    return (
      <div>
        <Row style={{ marginBottom: '15px' }}>
          <BackBtn />
        </Row>
        <Card>
          <DescriptionList size="large" col={3}>
            <Description term="项目名称">{data.name}</Description>
            <Description term="项目周期">
              {data.beginDate ? moment(data.beginDate).format('YYYY-MM-DD') : ''}至
              {data.endDate ? moment(data.endDate).format('YYYY-MM-DD') : '永久'}
            </Description>
            <Description term="项目分类">
              {data.type === 0 ? <span>绩效考核</span> : ''}
              {data.type === 1 ? <span>政府申报</span> : ''}
              {data.type === 2 ? <span>日常项目</span> : ''}
            </Description>
            <Description term="业务部门">{data.workorgName}</Description>
            <Description term="项目标签">
              {(data.tags || []).map(item => {
                return <Tag key={item}>{item}</Tag>;
              })}
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={1}>
            <Description term="项目描述">{data.remark}</Description>
          </DescriptionList>
          <Divider />
          <DescriptionList size="large" col={1}>
            <Description term="项目管理员">
              {(data.administrators || []).map(item => {
                return (
                  <span style={{ paddingLeft: '10px', paddingRight: '10px' }} key={item.uuid}>
                    {item.userName}
                  </span>
                );
              })}
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={1}>
            <Description term="项目审批人">
              {(data.reviewers || []).map(item => {
                return (
                  <span style={{ paddingLeft: '10px', paddingRight: '10px' }} key={item.uuid}>
                    {item.userName}
                  </span>
                );
              })}
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={1}>
            <Description term="项目参与人">
              {(data.viewables || []).map(item => {
                return (
                  <span style={{ paddingLeft: '10px', paddingRight: '10px' }} key={item.uuid}>
                    {item.userName}
                  </span>
                );
              })}
            </Description>
          </DescriptionList>
        </Card>
      </div>
    );
  }
}

export default PageInfo;



// WEBPACK FOOTER //
// ./src/components/task/project/PageInfo.js